var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { UserRepository } from '@amityco/js-sdk';
import useMemoAsync from '../../core/hooks/useMemoAsync';
export default function useReport(user) {
    const isFlaggedByMe = useMemoAsync(() => __awaiter(this, void 0, void 0, function* () {
        if ((user === null || user === void 0 ? void 0 : user.userId) && (user === null || user === void 0 ? void 0 : user.flagCount) > 0) {
            return UserRepository.isFlaggedByMe(user === null || user === void 0 ? void 0 : user.userId);
        }
        return false;
    }), [user]);
    const handleReport = () => {
        return isFlaggedByMe ? UserRepository.unflag(user === null || user === void 0 ? void 0 : user.userId) : UserRepository.flag(user === null || user === void 0 ? void 0 : user.userId);
    };
    return { isFlaggedByMe, handleReport };
}
//# sourceMappingURL=useReport.js.map